import React from 'react';
import PropTypes from 'prop-types';
import { imageMimeTypeExtensions } from '../../constants/mimeType';
import Button from '../../component/Button/Button';
import { first, size, chunk, map, without, isArray, split, find, forEach, remove, isEqual, toLower, last, includes, filter, get } from 'lodash';
import { logWarning } from '../../utils/env';
import fileTypes, { getFileTypeFromFile } from '../../constants/fileTypes';

var FileUploadStore = require('./../../store/fileUploadStore');
var withErrors = require('./../../utils/mixins/withError');
var helper = {
  Ui: require('../ui-helper'),
  Bootstrap: require('../bootstrap-helper')
};
var FileItem = require('./file-item');

var FileUploader = React.createClass({

  DROPZONE: "Dropzone",

  statics: {
    getAccept(accept){
      return isArray(accept)
        ? accept.join(',')
        : accept;
    }
  },

  propTypes: {
    onFileUpload: PropTypes.func,
    onCancelUpload: PropTypes.func,
    isMultiple: PropTypes.bool,
    /**
     * @deprecated The MIME type is sent by the browser.
     * So this is unreliable way for file validation.
     */
    accept: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array
    ]),
    extensions: PropTypes.array,
    progressKey: PropTypes.string,
    customIncorrectFormatMessage: PropTypes.string,
    cropImages: PropTypes.bool,

    imageType: PropTypes.string,
    imageQuality: PropTypes.number,
    isUploadButtonDisabled: PropTypes.bool,

    sizeConstraintsInMb: PropTypes.shape({
      [fileTypes.IMAGE]: PropTypes.number,
      [fileTypes.VIDEO]: PropTypes.number,
      [fileTypes.DOCUMENT]: PropTypes.number,
    })
  },

  cropper: null,

  getDefaultProps(){
    return {
      isMultiple: true,
      accept: null,

      imageType: 'image/jpeg',
      imageQuality: 0.95
    }
  },

  getInitialState(){
    return {
      files: [],
      uploadProgress: 0,
      uploadError: null,
      imageToCrop: null
    }
  },

  componentDidMount(){
    var { progressKey, cropImages, isMultiple, accept } = this.props;

    if (isMultiple && cropImages) {
      throw new Error('FileUploader: currently multiple image crop is not supported');
    }

    if (progressKey) {
      FileUploadStore.addChangeListener(this._onUploadProgressStore);
    }

    if (accept) {
      logWarning('FileUploader has deprecated accept prop. Please use extensions!')
    }
  },

  componentWillUnmount(){
    FileUploadStore.removeChangeListener(this._onUploadProgressStore);
  },

  _onUploadProgressStore(){
    var {progressKey} = this.props;
    this.setState({
      uploadProgress: FileUploadStore.getUploadProgress(progressKey)
    });
  },

  _onUploadProgressCallback(progressPercentage) {
    this.setState({uploadProgress: progressPercentage});
  },

  render(){
    const { accept, isMultiple } = this.props;
    const { imageToCrop } = this.state;

    return (
      <div className="file-upload-control">
        <helper.Ui.ErrorMessage errorMessage={this.state.error}/>
        <helper.Ui.DropZone multiple={isMultiple} onDrop={this._onDropFile}
                            accept={FileUploader.getAccept(accept)}
                            ref={this.DROPZONE}>
          {imageToCrop && (
            <ReactImageCrop
              ref={(cropper) => { this.cropper = cropper; }}
              src={imageToCrop.preview}
              style={{height: 400, width: '100%'}}
              aspectRatio={1}
              guides={false}
              dragMode='crop'
              viewMode={1}
            />
          )
          || this._getFiles()}
        </helper.Ui.DropZone>
        <helper.Ui.ProgressBar
          percent={this.state.uploadProgress}
          type="progress-micro"
        />
        <div className="btn-block">
          <helper.Bootstrap.Row>
            <div className='col-md-12 text-left'>
              <a className="btn btn-primary"
                 onClick={this._browseFile}><span>{i18n.t("Browse", {
                context: 'button',
                ns: 'main'
              })}</span></a>

              {imageToCrop && (
                <Button
                  primary
                  onClick={this.handleCropImage}
                >
                  {i18n.t('Add image')}
                </Button>
              )}
              &nbsp;
            </div>
          </helper.Bootstrap.Row>
        </div>

        <div className="form-actions">
          {this._renderControls()}
        </div>
      </div>
    );
  },

  _getFiles(){
    var {files} = this.state;
    if (!files) {
      return null;
    }

    var fileRows = chunk(files, 4);

    return map(fileRows, this._getFilesRow);
  },

  _getFilesRow(filesRowData, index){
    return (
      <div key={index} className="row">
        {map(filesRowData, this._getFileItem)}
      </div>
    )
  },

  _getFileItem(fileItemData, index){

    return (
      <FileItem
        key={index}
        name={fileItemData.name}
        mimeType={fileItemData.type}
        previewUrl={fileItemData.preview}
      >
        {this._getFileItemActions(fileItemData)}
      </FileItem>
    )
  },

  _renderControls(){
    var { isUploadButtonDisabled } = this.props;
    const { uploadProgress } = this.state;
    const isLoading = uploadProgress > 0 && uploadProgress < 100

    return (
      <helper.Bootstrap.Row>
        <div className='col-md-12'>
          <a className="btn btn-primary"
             disabled={isUploadButtonDisabled || isLoading}
             onClick={!isLoading && this.props.onCancelUpload}>
                <span>{i18n.t("Cancel", {
                  context: 'button',
                  ns: 'main'
                })}
                </span>
          </a>&nbsp;
          {!!this.state.files.length &&
          <a className="btn btn-primary"
             disabled={isUploadButtonDisabled || isLoading}
             onClick={!isLoading && this._onClickListener}>
                <span>{i18n.t("Upload", {
                  context: 'button',
                  ns: 'main'
                })}
                </span>
          </a>}&nbsp;
        </div>
      </helper.Bootstrap.Row>
    )
  },

  _onClickListener() {
    var { isUploadButtonDisabled } = this.props;

    if (isUploadButtonDisabled) {
      return false;
    } else {
      this._uploadFile();
    }
  },

  _getFileItemActions(fileItem){
    return (
      <div className="actions">
        <a className="action"
           onClick={this._removeFileItem.bind(this, fileItem)}>{i18n.t("Remove", {
          context: 'fileUpload',
          ns: 'main'
        })}</a>
      </div>
    )
  },

  _removeFileItem(fileItem){
    var {files} = this.state;
    this.setState({files: without(files, fileItem)});
  },

  _getFileNameExtension(fileName){
    const nameAndExtension = split(fileName, '.');
    return toLower(last(nameAndExtension));
  },

  _onDropFile(files, rejectedFiles){
    const { cropImages } = this.props;
    if (cropImages && size(files) > 0) {
      const file = first(files);
      if (imageMimeTypeExtensions.isImage(file.type)) {
        this.setState({ imageToCrop: file, files: [] });
        return;
      }
    }

    if (this.props.extensions) {
      forEach(files, (file) => {
        const fileExtension = this._getFileNameExtension(file.name);
        const checkFileForExtension = find(this.props.extensions, (ext) => fileExtension === ext);
        if (!checkFileForExtension) {
          remove(files, (item) => isEqual(item, file));
          rejectedFiles.push(file);
        }
      });
    }

    this._processFileDrop(files, rejectedFiles);
  },

  _processFileDrop(files, rejectedFiles) {
    const { isMultiple, customIncorrectFormatMessage } = this.props;

    const droppedFiles = (isMultiple || !files.length) ? this.state.files : [];
    let error = [];

    if (rejectedFiles.length) {
      error.push(customIncorrectFormatMessage || `File(s) ${rejectedFiles.map(file => file.name).join(', ')} have unsupported format`);
    }

    const validationResult = this._validateFiles(files);

    if (validationResult.error) {
      error.push(validationResult.error);
    }

    this.setState({
      files: droppedFiles.concat(validationResult.validFiles),
      error,
    });
  },

  _browseFile(e){
    this.refs[this.DROPZONE].openFileDialog();
  },

  handleCropImage() {
    const croppedCanvas = this.cropper.getCroppedCanvas({ fillColor: '#FFFFFF' });

    if (!croppedCanvas) {
      const error = i18n.t('Invalid image file');
      this.setState({ error, imageToCrop: null });
      return;
    }

    croppedCanvas.toBlob(this.processCroppedImage, this.props.imageType, this.props.imageQuality);
  },

  processCroppedImage(croppedImageFile) {
    croppedImageFile.name = this.state.imageToCrop.name;
    this.setState({ imageToCrop: null }, () => {
      this._processFileDrop([croppedImageFile], []);
    });
  },

  _uploadFile(){
    this.setState({
      uploadProgress: 0,
      uploadError: null
    });

    var {files} = this.state;
    var {onFileUpload} = this.props;

    if (this.props.progressKey) {
      onFileUpload(files);
    } else {
      onFileUpload(files, this._onUploadProgressCallback);
    }

  },

  _validateFiles(files) {
    if (this.props.sizeConstraintsInMb) {
      return this._validateFileSize(files, this.props.sizeConstraintsInMb);
    }
    return {
      validFiles: files,
      invalidFiles: [],
      error: null
    };
  },

  _validateFileSize(files, sizeConstraintsInMb) {
    let error = '';

    const invalidFiles = sizeConstraintsInMb
      ? filter(files, file => {
        const fileType = getFileTypeFromFile(file);
        const maxFileSize = get(sizeConstraintsInMb, fileType) || Infinity;
        const isInvalid = file.size > maxFileSize * 1024 * 1024;

        if (isInvalid) {
          error += `File ${file.name} should be less than ${maxFileSize} Mb \n`;
        }
        return isInvalid;
      })
      : [];

    return {
      invalidFiles,
      validFiles: filter(files, file => !invalidFiles.includes(file)),
      error: error || null
    };
  }

});

module.exports = withErrors(FileUploader);

